import { createAction } from '@reduxjs/toolkit';

const deleteTranscript = createAction('asset/deleteTranscript');

export default deleteTranscript;
